import { Image } from "@chakra-ui/react";

interface Props {
  isOpen: boolean;
  forHeading?: boolean
}

export function ExpandChevron({ isOpen, forHeading = false }: Props) {
  return (
    <Image
      display="inline-block"
      h={4}
      mr={2}
      mt={Number(forHeading)}
      src="/svg/chevron.svg"
      transform={`${forHeading ? "translateY(2px)" : ""} rotate(${isOpen ? 180 : 0}deg)`}
      transition="transform 0.2s"
      w={4}
    />
  );
}